import { render, staticRenderFns } from "./StartTab.vue?vue&type=template&id=de39e202&scoped=true&"
import script from "./StartTab.vue?vue&type=script&lang=ts&"
export * from "./StartTab.vue?vue&type=script&lang=ts&"
import style0 from "./StartTab.vue?vue&type=style&index=0&id=de39e202&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de39e202",
  null
  
)

export default component.exports